import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useOperationStore } from "@/stores/operation";
import { getFileData } from "@/libs/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerView',
  props: {
  direction: {
    type: String,
    default: "right",
  },
},
  setup(__props) {

const props = __props;

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const files = op.value?.files;

const banner = computed(() => {
  return files ? getFileData(files, "banner_mb") : null;
});

const banner_mobile = computed(() => {
  return files ? getFileData(files, "banner_mobile_mb") : null;
});

// eslint-disable-next-line no-undef


return { __sfc: true,operationStore, op, files, banner, banner_mobile, props }
}

})